import React, {Component} from 'react';
import {connect} from 'react-redux';

class Select extends Component {
    constructor(props) {
        super(props);
        this.change = this.change.bind(this);
    }
    
    change (e) {
        this.props.dispatch(this.props.action(e.target.value));
    }
    
    render() {
        const blank = this.props.blank ? 'l-row l-blank' : 'l-row';
        const mt = this.props.mt ? ' l-mtSS' : '';
        const wrapStyle =  blank + mt;
        
        return (
            <div className={wrapStyle}>
                <label>{this.props.label + '：'}</label>
                <select className={this.props.class} value={this.props.value} onChange={e => this.props.action === null ? this.props.change(e) : this.change}>
                    {this.props.options.map((el, index) => (
                        <option key={index} value={el.val}>{el.text}</option>
                    ))}
                </select>
            </div>
        );
    }
};

export default connect()(Select);